<template>
    <div class="Projection">
        <transition @enter="enter" @leave="leave">
            <div ref="container" class="Projection__container">
                <video class="Projection__movie" :class="is_playing ? '' : 'hidden' " ref="movie">
                    <source 
                        src="/static/meneath-desktop.webm"
                        type="video/webm"
                    >
                    <source 
                        src="/static/meneath-desktop.mov" 
                        type='video/mp4; codecs="hvc1"'
                    >
                    <track 
                        src="/static/eng_subtitles.vtt" 
                        label="English" 
                        kind="captions" 
                        srclang="en-us" 
                        default
                        v-if="this.subtitles == 1"
                    >
                    <track 
                        src="/static/fr_subtitles.vtt" 
                        label="Français"
                        kind="captions"
                        srclang="fr-ca" 
                        default
                        v-if="this.subtitles == 2"
                    >
                </video>   
                <div class="Projection__border"> 
                    <img :src="require('@/commons/images/bg_desktop.png')">
                </div> 
            </div>
        </transition>
        <!-- <Welcome v-if="is_welcome"/> -->
        <Instructions :room="$room" v-if="!is_playing"/>
        <div class="Projection__redirect">
            <img class="Instructions__logo" src="@/commons/images/meneath_titre_en.png" alt="meneath">
            <div class="Instructions__description">Meneath is an augmented reality experience that requires the use of a computer or tablet.</div>
            <img class="Instructions__icon" src="@/commons/images/mobile_desktop.png">
            <hr>
            <div class="Instructions__description">Open this website on a desktop computer or a tablet to begin.</div>
            <div class="Instructions__description">Follow the instructions on the website to launch the experience.</div>
        </div>
        <Credits v-if="current >= 1170" />
        <!-- <div class="Projection__cue"> : {{ current }}</div> -->
    </div>
</template>

<script>

import Welcome from '@/components/projection/Welcome'
import Instructions from '@/components/projection/Instructions'
import Credits from '@/components/projection/Credits'

export default {

    name: 'Projection',
    components: { Welcome, Instructions, Credits },
    data: ()=>({
        is_playing: false,
        cue: 0,
        laps: 300,
        delay: 1,
        is_welcome: true,
        is_playing: false,
        current: 0,
        subtitles: 0,
    }),  
    beforeDestroy() {
        this.$socket.emit('masterLeaveRoom', this.$room) 
        this.stopRAF()   
    },
    created(){
        this.$room = _.random(1000, 5000)
        this.$video = this.$route.params.video ? this.$route.params.video : 'meneath_ar_background'
    },
    mounted() {
        TweenMax.delayedCall(this.delay, ()=>{
            if(this.$socket.connected)
                this.$socket.emit('joinSession', this.$room, 'projection')
        })
        document.addEventListener('keypress', this.onKeyPress)
    },
    computed: {
        start_movie() { return this.$store.getters['socket/start_movie'] },
        user_leave() { return this.$store.getters['socket/user_leave'] },
    },
    watch: {
        'is_playing'(nw){
            console.log('---');
            if(nw)
                this.startMovie()
        },
        start_movie(nw, od) {
            if(nw == true)
                this.is_playing = true
        },
        user_leave(nw, od){

            console.log('user_leave : '+ nw);

            if(nw == null)
                return
            
            this.stopRAF()
            this.$refs.movie.pause()  
            this.is_playing = false
        },
    },
    methods: {
        stopRAF() {
            cancelAnimationFrame(this.$raf)  
            this.cue = 0  
        },   
        restartMovie() {
            if(this.is_playing){
                this.stopRAF()
                this.$refs.movie.pause()  
                this.is_playing = false
            }
            else this.startMovie()
        },
        startMovie() {
            console.log(this.$store.getters['socket/subtitles']);
            console.log('startMovie');
            this.subtitles = this.$store.getters['socket/subtitles'];
            this.$raf = requestAnimationFrame(this.onLoop)
            this.$refs.movie.play()
            this.$refs.movie.currentTime = this.current
            this.is_playing = true
        },

        continueMovie() {
            console.log('continueMovie');
            this.$refs.movie.play()
            this.$refs.movie.currentTime = this.current
            this.is_playing = true
            this.$raf = requestAnimationFrame(this.onLoop)
        },

        onLoop() {
            this.cue +=1
            if(this.cue == this.laps){
                this.cue = 0
                console.log(this.$refs.movie.currentTime);
                this.current = this.$refs.movie.currentTime
                this.$socket.emit('setTimeProjection', { room: this.$room, time: this.$refs.movie.currentTime, utc: Date.now() })   
            }
            this.$raf = requestAnimationFrame(this.onLoop)
        },

        enter(done) { done() },
        leave(done) { done() }, 

        onKeyPress() {
            console.log('onKeyPress');
            this.restartMovie()
        },
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Projection
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color white
    background black
    display flex 
    justify-content center
    align-items center

    &__container 
        width 100%
        max-width 880px
        position relative
        display flex 
        justify-content center
        align-items center

        height 100%

    &__movie
        overflow hidden
        position absolute
        top 49%
        left 50%
        transform translate(-50%, -50%)
        background-color white
        width 120%
        z-index 100

    &__border 
        z-index 50
        position absolute
        width 1920px
        height 1200px
        top 50%
        transform: translateY(-50%)

    &__cue 
        position absolute
        top 0 
        left 0
        color white
        background black
        padding 4px 8px
        z-index 10000
    
    &__redirect {
        display: none
    }

@media screen and (max-width: 1110px) {
    .Projection {
        &__redirect {
            padding 10% 10%
            width: 100%
            height: 100%
            display: flex
            flex-direction: column
            align-items: center
            justify-content center
            background-image: url('~@/commons/images/bg_texture.jpg')
            background-size: cover
        }

        &__container {
            display: none
        }

        .Instructions__description {
            text-align: center
            margin: 16px 0px
        }

        hr {
            margin-top: 32px
            margin-bottom: 16px
            width: 100%
        }

        .Instructions__logo{
            margin-top: 84px;
            max-width: 70%;
            margin-bottom: 16px
        }
    }

    .Instructions {
        display: none;

        &__icon {
            max-width: 50%
        }
    }
}
</style>